<div class="row gx-0 mb-3 ai-summary-wrapper" *ngIf="isShowing && isRagParamInUrl">
  <div class="col">
    <!-- AI Summary Header Row -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <!-- Left-aligned Heading -->
      <h5 class="ai-summary-heading m-0">AI Summary:</h5>

      <!-- Right-aligned Metadata -->
      <div class="ai-summary-metadata text-end" *ngIf="text !== 'There are no AIProviders configured.'">
        <p class="m-0" *ngIf="qSummaryTimeSeconds > 0 && !aiModel">
          AI Summary generated in {{qSummaryTimeSeconds}} seconds.
        </p>
        <p class="m-0" *ngIf="qSummaryTimeSeconds > 0 && aiModel">
          AI Summary generated by {{aiModel}} in {{qSummaryTimeSeconds}} seconds.
        </p>
      </div>
    </div>

    <!-- Error Message -->
    <div *ngIf="text === 'There are no AIProviders configured.' && !isLoading" class="ai-error-wrapper">
      {{ text }}
    </div>

    <!-- Loading Indicator -->
    <div class="d-flex justify-content-start position-relative">
      <div *ngIf="isLoading" class="spinner-border ai-summary-spinner" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- AI Summary Text -->
    <div *ngIf="!isLoading && text !== 'There are no AIProviders configured.'" class="ai-summary-text" [innerHtml]="text"></div>

    <!-- Rating buttons (only if not yet rated) and RAG rating feature is enabled -->
    <div class="rating-container mb-3" *ngIf="ragRatingEnabled && !rated && !isLoading && text !== 'There are no AIProviders configured.'">
        <button class="btn-icon thumbs-up"
                (click)="onThumbsUp()"
                [disabled]="rated || showFeedbackBox">
            <img [src]="lastRating === 1 ? thumbsUpActiveIcon : thumbsUpIcon" alt="Thumbs Up">
        </button>
        <button class="btn-icon thumbs-down"
                (click)="onThumbsDown()"
                [disabled]="rated || showFeedbackBox">
            <img [src]="lastRating === 0 ? thumbsDownActiveIcon : thumbsDownIcon" alt="Thumbs Down">
        </button>
    </div>

    <!-- Feedback box and suggestions -->
    <div *ngIf="!rated && showFeedbackBox" class="feedback-options mb-3">
        <p class="feedback-prompt">How would you qualify this answer?</p>
        <!-- Suggestion buttons: auto-submit on click -->
        <div class="suggestions">
            <button
                    *ngFor="let s of suggestions"
                    class="suggestion-btn"
                    (click)="submitFeedback(s)">
                {{ s }}
            </button>
            <!-- “Other” triggers the modal -->
            <button
                    class="suggestion-btn"
                    (click)="openOtherModal()">
                Other
            </button>
        </div>
    </div>
    <div class="modal fade" [ngClass]="{ 'show d-block': showOtherModal}"
         tabindex="-1"
         role="dialog"
         (click)="closeOtherModal()">
        <div class="modal-dialog" role="document" (click)="$event.stopPropagation()">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Provide additional feedback</h5>
                    <button
                            type="button"
                            class="btn-close"
                            (click)="closeOtherModal()">
                    </button>
                </div>
                <div class="modal-body">
                    <textarea
                            [(ngModel)]="feedbackText"
                            class="form-control"
                            rows="4"
                            placeholder="Type your feedback…">
                    </textarea>
                </div>
                <div class="modal-footer">
                    <button
                            type="button"
                            class="btn btn-secondary"
                            (click)="closeOtherModal()">
                        Cancel
                    </button>
                    <button
                            type="button"
                            class="btn btn-primary"
                            [disabled]="!feedbackText.trim()"
                            (click)="submitFeedback(feedbackText); closeOtherModal()">
                        Submit
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Thanks banner -->
    <div class="alert alert-success text-center" *ngIf="showThanksMessage">
        Thanks for your feedback!
    </div>
  </div>
</div>
